import { ICDAuxCheckboxModel } from "./icd-aux-checkbox.model";
import { ICDBaseModel } from "./icd-base.model";

export class ICDCheckboxModel extends ICDBaseModel {
  public auxModel: ICDAuxCheckboxModel = null;
  private _value: boolean;
  public enumRef: string = null;

  constructor(value?: boolean) {
    super();
    this._value = value != null ? value : null;
  }

  public get value(): boolean {
    return this._value;
  }
  public set value(value: boolean) {
    this._value = value;
  }
}
